import { Provider } from 'jotai';
import { MapProvider } from '../contexts/MapPositionContext';

interface JotaiProviderProps {
  children: React.ReactNode;
}

export function JotaiProvider({ children }: JotaiProviderProps) {
  return (
    <Provider>
      <MapProvider>
        {children}
      </MapProvider>
    </Provider>
  );
}